import { ref } from 'vue'

// Google AdSense client ID - replace with your actual ID
const AD_CLIENT = 'ca-pub-8930399943527038'
const AD_SLOT = 'XXXXXXXXXX'

export function useAds() {
  const adLoading = ref(false)
  const adError = ref(null)

  function showRewardedAd(containerEl) {
    return new Promise((resolve) => {
      adLoading.value = true
      adError.value = null

      try {
        // Check if AdSense is loaded
        if (window.adsbygoogle) {
          // Create ad element
          const ins = document.createElement('ins')
          ins.className = 'adsbygoogle'
          ins.style.display = 'block'
          ins.style.width = '100%'
          ins.style.height = '280px'
          ins.setAttribute('data-ad-client', AD_CLIENT)
          ins.setAttribute('data-ad-slot', AD_SLOT)
          ins.setAttribute('data-ad-format', 'auto')
          ins.setAttribute('data-full-width-responsive', 'true')

          containerEl.innerHTML = ''
          containerEl.appendChild(ins)

          window.adsbygoogle.push({})

          // Resolve after a reasonable viewing time
          setTimeout(() => {
            adLoading.value = false
            resolve()
          }, 5000)
        } else {
          // AdSense not loaded - simulate ad for development
          console.warn('AdSense not loaded. Simulating ad...')
          simulateAd(containerEl, resolve)
        }
      } catch (err) {
        console.error('Ad error:', err)
        adError.value = err.message
        adLoading.value = false
        // Don't block the user on ad failure
        simulateAd(containerEl, resolve)
      }
    })
  }

  function simulateAd(containerEl, resolve) {
    // Development placeholder - shows a timer
    containerEl.innerHTML = ''
    const div = document.createElement('div')
    div.style.cssText = 'display:flex;align-items:center;justify-content:center;height:280px;background:#222;border-radius:8px;color:#888;font-size:14px;flex-direction:column;gap:8px;'

    let seconds = 5
    const counter = document.createElement('div')
    counter.style.cssText = 'font-size:32px;font-weight:bold;color:white;'
    counter.textContent = seconds

    const label = document.createElement('div')
    label.textContent = 'Ad placeholder — will show real ad in production'

    div.appendChild(counter)
    div.appendChild(label)
    containerEl.appendChild(div)

    const timer = setInterval(() => {
      seconds--
      counter.textContent = seconds
      if (seconds <= 0) {
        clearInterval(timer)
        adLoading.value = false
        resolve()
      }
    }, 1000)
  }

  return {
    adLoading,
    adError,
    showRewardedAd
  }
}
